module.exports = __webpack_public_path__ + "static/grandview-logo-white-3acd656838221f05e9dc54d0580f8100.png";